document.addEventListener('DOMContentLoaded', function() {
  console.log('Script is running');
  const section = document.getElementById('template--26478852243776__contact_form_9RU6B6');
  console.log('Section found:', section);
  if (section) {
    const textarea = section.querySelector('textarea');
    console.log('Textarea found:', textarea);
    if (textarea) {
      textarea.placeholder = 'Message — please include store name';
      console.log('Placeholder updated');
    }
  }
});
